const caregivers = {
  tabs: {
    history: 'Geschichte',
    information: 'Information',
  },

  headerButtons: {
    create: {
      createBtn: 'Erstellen',
    },
  },

  modal: {
    header: 'Status ändern',
    body: 'Are you sure you want to change the parent status to ',
  },

  edit: {
    tabs: {
      information: 'Information',
      linkStudent: 'Schüler',
      history: 'Geschichte',
      bookingHistory: 'Buchungsverlauf',
    },
  },

  table: {
    statuses: {
      active: 'Aktiv',
      inactive: 'Inaktiv',
    },

    header: {
      createBtn: 'Erstellen',
      name: 'Name',
      email: 'E-Mail',
      phone: 'Telefon',
      status: 'Status',
      address: 'Adresse',
      createdBy: 'Erstellt von',
      createdAt: 'Erstellt am',
    },
  },
  form: {
    header: {
      create: {
        title: 'Erstellen',
      },

      update: {
        title: 'Aktualisieren',
      },
    },

    footer: {
      confirmButtonText: {
        create: 'Einreichen',
        update: 'Einreichen',
      },
    },

    actions: {
      header: 'Aktionen',
      buttons: {
        resetPassword: 'Passwort zurücksetzen',
      },
    },

    create: {
      toasts: {
        success: 'Betreuer erfolgreich erstellt',
        error: 'Beim Erstellen des übergeordneten Elements ist ein Fehler aufgetreten',
      },
    },
    update: {
      formTabs: {
        informationTab: 'Information',
        notesTab: 'Hinweise',
        historyTab: 'Geschichte',
      },

      activeStatus: {
        statusActive: 'Aktiv',
        statusDeactivate: 'Inaktiv',
      },

      suspend: {
        actionActivate: 'Aufheben der Sperre',
        actionDeactivate: 'Sperren',
        suspendModal: {
          popupTitleDeactivation: 'Fahrgast sperren',
          popupTitleActive: 'Grund für die Sperrung',
          popupTitleUnsuspend: 'Grund für die Aufhebung der Sperrung',
          popupSubTitleDeactivation: 'Wählen Sie den Grund für die Sperrung aus',
          popupActionActive: 'Fahrgastsperrung aufheben',
          popupActionDeactivate: 'Fahrgast sperren',
        },
      },
      toasts: {
        success: 'Übergeordnetes Element erfolgreich aktualisiert',
        error: 'Beim Aktualisieren des übergeordneten Elements ist ein Fehler aufgetreten',
        fetchError: 'please try again.,Etwas ist schiefgelaufen, bitte versuchen Sie es erneut., please try again.',
      },
    },
    sections: {
      groups: {
        header: 'Seite & Profil',
        fields: {
          profile: {
            label: 'Profil',
          },
        },
      },
      personalDetails: {
        header: 'Persönliche Daten',
        fields: {
          firstName: {
            label: 'Vorname',
          },
          lastName: {
            label: 'Nachname',
          },
          email: {
            label: 'E-Mail',
          },
          phone: {
            label: 'Telefon',
          },
          additionalPhone: {
            label: 'Zusätzliches Telefon',
          },
          mainAdddres: {
            label: 'Adresse',
          },
          schoolAddres: {
            label: 'Schule',
          },
        },
      },
      linkAttendant: {
        linkedHeader: 'Verknüpfte Schüler',
        listHeader: 'Schülerliste',
        noResultsLinkedTable: 'Noch keine Schüler verknüpft',
        noResultsLinkedTableSubHeader: 'Fügen Sie Schüler aus der Liste unten hinzu',
        noResultsListTable: 'Keine Schüler gefunden',
        noResultsListTableSubHeader: 'Wir können keinen Artikel finden, der Ihrer Suche entspricht',
      
        add: 'Hinzufügen',
        entity: 'Schüler',
      },
    },
  },

  attendantsTable: {
    headers: {
      name: 'Name',
      address: 'Adresse',
      phone: 'Telefon',
      email: 'E-Mail',
    },
  },
};

export default caregivers;
